module.exports = __webpack_public_path__ + "static/media/contact-bg.2e396698.svg";